export const historyPriceModalInit = () => {
  document.addEventListener('click', function(e) {
    const target = e.target.closest('.property-history-price');

    if (target) {
      const apartmentId = target.dataset.apartmentId;
    const bodyEl = document.querySelector('body');
    const modal = document.querySelector('.history-price-modal');
    const content = modal.querySelector('.history-price-modal__body');
    const modalContent = modal.querySelector('.history-price-modal__content');
    const modalClose = modal.querySelector('.history-price-modal__close');

    modalClose.addEventListener('click', function () {
      modal.classList.remove('show');
      bodyEl.classList.remove('overflow-hidden');
    });

    modal.addEventListener('click', (event) => {
      if (!modalContent.contains(event.target)) {
        modal.classList.remove('show');
        bodyEl.classList.remove('overflow-hidden');
      }
    });

      content.innerHTML = '';
      bodyEl.classList.add('overflow-hidden');

      fetch(`${antrans_ajax.ajax_url}?action=property_history_price&id=${apartmentId}`)
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          console.log(res, 'res');
          content.innerHTML = res.data.html;
          modal.classList.add('show');
        } else {
          content.innerHTML = 'Błąd: nie udało się pobrać danych.';
        }
      })
      .catch(() => {
        content.innerHTML = '<p>Wystąpił błąd połączenia.</p>';
      });
    }
});
}